/*
  Project: Wchealth
  Author: xfive
 */

import HomeSlider from './modules/home-slider';
import GoogleTrans from './modules/google-trans';
import GoogleMap from './modules/google-map';
import MobileNav from './modules/mobile-nav';
import Underline from './modules/underline';

/* eslint-disable */

new HomeSlider();
new GoogleTrans();
new GoogleMap();
new MobileNav();
new Underline();



// WEBPACK FOOTER //
// ./src/scripts/app.js